
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[athleteSlug]/social-media-post/video/[mediaPostSlug]",
      function () {
        return require("private-next-pages/[athleteSlug]/social-media-post/video/[mediaPostSlug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[athleteSlug]/social-media-post/video/[mediaPostSlug]"])
      });
    }
  